"use client";
import { TextProps } from "@/types/sections/text";
import clsx from "clsx";

export default function TextDefaultSection({ data }: { data: TextProps }) {
  const {
    title,
    description,
    content,
    alignment = "left",
    width = "md",
    background,
  } = data;

  // Map width prop to max-w utility
  const widthClass = {
    sm: "max-w-sm",
    md: "max-w-2xl",
    lg: "max-w-4xl",
    xl: "max-w-6xl",
    full: "max-w-none",
  }[width];

  const textAlign = {
    left: "text-left",
    center: "text-center",
    right: "text-right",
  }[alignment];

  const backgroundStyle =
    background?.type === "color"
      ? { backgroundColor: background.value }
      : background?.type === "gradient"
        ? { backgroundImage: background.value }
        : background?.type === "image"
          ? {
              backgroundImage: `url(${background.value})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }
          : {};

  return (
    <section style={backgroundStyle} className="py-14 px-4">
      <div className={clsx("mx-auto space-y-6", widthClass, textAlign)}>
        {title && <h2 className="text-3xl font-bold">{title}</h2>}
        {description && <p className="text-muted-foreground">{description}</p>}
        {content && (
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
      </div>
    </section>
  );
}
